module.exports = __webpack_public_path__ + "img/83.4b0cd02f.svg";